import { Flex, Typography } from '@iheartjane/reefer';

import { ProductsConditions } from '@jane/business-admin/components/shared/specials/modal/conditions/ProductsConditions';
import {
  ConditionType,
  FORM_FIELD_DEFAULT_MARGIN,
} from '@jane/business-admin/components/shared/specials/modal/form';

import { MenuRowCard } from './MenuRowModal';

export const ThresholdsConditionsCard = () => {
  return (
    <MenuRowCard>
      <Flex flexDirection="column">
        <Typography variant="header-bold" branded>
          Conditions
        </Typography>
        <Typography color="grays-mid" mb={FORM_FIELD_DEFAULT_MARGIN}>
          By default, this includes all new products except gear and
          merchandise. Exclude specific products below.
        </Typography>

        <ProductsConditions
          disableAddButton={false}
          fieldPrefix=""
          type={ConditionType.ExcludeProducts}
        />
      </Flex>
    </MenuRowCard>
  );
};
